import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getRestaurantDetails } from "../actions/restaurantActions";
import SwitchOnAndOff from "../components/SwitchOnAndOff";
import Loader from "../components/Loader";
import Messages from "../components/Messages";
import styled from "styled-components";
import SubMenu from "../components/SubMenu";
import {
  updateRestaurant,
  createRestaurant,
} from "../actions/restaurantActions";
import TimeInputLessPlus from "../components/TimeInputLessPlus";
import Separator from "../components/Separator";
import { Row, Col } from "react-bootstrap";
import moment from "moment-timezone";
import DropDownButton from "../components/DropDownButton";
import {
  GoogleMap,
  Marker,
  useLoadScript,
  useJsApiLoader,
} from "@react-google-maps/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock, faSquarePhoneFlip } from "@fortawesome/free-solid-svg-icons";
import { getDialCode, getCountryCode } from "../components/CountryCode";
import InputDayOrHour from "../components/InputDayOrHour";
import InputDayOrHourInt from "../components/InputDayOrHourInt";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
/* global google */
import {
  Container,
  CardHeader,
  CardHeaderTitle,
  Input,
  ModernButton,
  SettingsCard,
  SectionTitle,
  Text,
  GridContainer,
  CustomSpan,
  StyledSelect,
} from "../components/DefaultImports";
import { CustomModal } from "../components/CustomModal";

const getTimezone = () => {
  if (window.Intl && window.Intl.DateTimeFormat) {
    const options = new window.Intl.DateTimeFormat().resolvedOptions();
    return options && options.timeZone ? options.timeZone : "";
  }

  return "";
};

const getBooleanValue = (value, fallback = true) => {
  if (typeof value === "boolean") return value;
  if (value === 1 || value === "1" || value === "true") return true;
  if (value === 0 || value === "0" || value === "false") return false;

  return fallback;
};

function RestaurantSettingsUpdate({
  creating_restaurant = "no",
  handleNextStep = false,
  restaurant_id = false,
  restaurantCreated = false,
  setCreateRestaurantToFalse = false,
  steps = false,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const params = useParams();
  const [restaurantId, setRestaurantId] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("ok_status");
  const [showPeopleLimitUpgradeModal, setShowPeopleLimitUpgradeModal] =
    useState(false);
  const [
    showReservationExtrasUpgradeModal,
    setShowReservationExtrasUpgradeModal,
  ] = useState(false);
  const [
    showGroupSizeAcceptanceUpgradeModal,
    setShowGroupSizeAcceptanceUpgradeModal,
  ] = useState(false);
  const [showAutoAcceptanceUpgradeModal, setShowAutoAcceptanceUpgradeModal] =
    useState(false);

  const [restaurantName, setRestaurantName] = useState("");
  const [address, setAddress] = useState("");
  const [postalCode, setPostalCode] = useState(false);

  const [longitudeField, setLongitudeField] = useState(0.0);
  const [latitudeField, setLatitudeField] = useState(0.0);
  const [viewDistance, setViewDistance] = useState(18);

  const [numberOfChairs, setNumberOfChairs] = useState(0);
  const [numberOfBabyChairs, setNumberOfBabyChairs] = useState("");
  const [limitPeopleReservation, setLimitPeopleReservation] = useState("");
  const [limitBabyChairsReservation, setLimitBabyChairsReservation] =
    useState("");
  const [autoAcceptLimit, setAutoAcceptLimit] = useState("");
  const [eachTime, setEachTime] = useState("00:15");
  const [acceptPeoplePerEachTime, setAcceptPeoplePerEachTime] = useState("");
  const [timezone, setTimezone] = useState(getTimezone());
  const timezones = moment.tz.names();
  const [autoAcceptTimeLimit, setAutoAcceptTimeLimit] = useState("");
  const [autoAcceptTimeLimitFuture, setAutoAcceptTimeLimitFuture] =
    useState("");
  const [messageReminderTime, setMessageReminderTime] = useState("");
  const [autoSetTables, setAutoSetTables] = useState(null);
  const [showTableNotFreedNotification, setShowTableNotFreedNotification] =
    useState(true);
  const [timeToCancelledWarning, setTimeToCancelledWarning] = useState("");
  const [
    stop_allowing_modifications_time_before_date,
    setStop_allowing_modifications_time_before_date,
  ] = useState(0);
  const [
    stop_allowing_cancelling_time_before_date,
    setStop_allowing_cancelling_time_before_date,
  ] = useState(0);

  const [countryCode, setCountryCode] = useState("pt");
  const [restaurant_description, setRestaurant_description] = useState("");
  const [reconfirmation_duration, setReconfirmation_duration] = useState("");
  const [reconfirmation_time_before_date, setReconfirmation_time_before_date] =
    useState("");
  const [sizeError, setSizeError] = useState("");

  const [restaurant_params, setRestaurant_params] = useState({});

  const { isLoaded: isGoogleLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyDtPooGWkj4z_ExlO9ggRMwwI9QiFZuZTI",
  });

  const [marker, setMarker] = useState(false);
  const [firstTimeChekcer, setFirstTimeChekcer] = useState(false);
  const [allowGeocode, setAllowGeocode] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setAllowGeocode(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (allowGeocode && postalCode && isGoogleLoaded) {
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ address: postalCode }, (results, status) => {
        if (status === "OK") {
          const location = results[0].geometry.location;

          setLatitudeField(location.lat());
          setLongitudeField(location.lng());
          setMarker({
            lat: location.lat(),
            lng: location.lng(),
          });
        } else {
          console.error(
            "Geocode was not successful for the following reason:",
            status,
          );
        }
      });
    }
  }, [postalCode, isGoogleLoaded, allowGeocode]);

  const detectCountryCode = () => {
    const userCountryCode = navigator.language.split("-")[1];
    const formattedCountryCode = userCountryCode
      ? userCountryCode.toLowerCase()
      : "us";

    return formattedCountryCode;
  };

  const handleOnZoomChanged = React.useCallback((map) => {
    const zoomLevel = map.getZoom();
    setViewDistance(zoomLevel);
  }, []);

  const onMapClick = React.useCallback((event) => {
    setMarker({
      lat: event.latLng.lat(),
      lng: event.latLng.lng(),
    });
    setLatitudeField(event.latLng.lat());
    setLongitudeField(event.latLng.lng());
  }, []);

  const handleOnLoad = (map) => {
    if (isGoogleLoaded) {
      google.maps.event.trigger(map, "resize");
      map.addListener("zoom_changed", () => handleOnZoomChanged(map));
    }
  };

  const restaurantDetails = useSelector((state) => state.restaurantDetails);
  const { restaurants, isLoading, error } = restaurantDetails;

  const isPeopleLimitBlocked =
    Number(restaurants?.sub_lvl) === 1 ||
    !restaurants ||
    Number(restaurants?.sub_lvl) === 0;

  const isReservationExtrasBlocked =
    Number(restaurants?.sub_lvl) === 1 ||
    !restaurants ||
    Number(restaurants?.sub_lvl) === 0;

  const isGroupSizeAcceptanceBlocked =
    Number(restaurants?.sub_lvl) === 1 ||
    !restaurants ||
    Number(restaurants?.sub_lvl) === 0;

  const isAutoAcceptanceBlocked =
    Number(restaurants?.sub_lvl) === 1 ||
    !restaurants ||
    Number(restaurants?.sub_lvl) === 0;

  const generateIntervalOptions = () => {
    const intervalOptions = [];

    for (let i = 0; i < 24; i++) {
      for (let j = 0; j < 60; j += 15) {
        const hour = i.toString().padStart(2, "0");
        const minute = j.toString().padStart(2, "0");
        const time = `${hour}:${minute}`;

        if (time >= "00:15" && time <= "08:00") {
          intervalOptions.push(time);
        }
      }
    }

    return intervalOptions;
  };

  const generateNumberOptions = () => {
    const numberOptions = [];

    for (let i = 0; i < 100; i++) {
      numberOptions.push(i);
    }

    return numberOptions;
  };

  const [numberOptions, setNumberOptions] = useState(generateNumberOptions());
  const [intervalOptions, setIntervalOptions] = useState(
    generateIntervalOptions(),
  );

  let initialData;

  useEffect(() => {
    if (restaurants) {
      setRestaurantId(restaurants.id);
    }
  }, [restaurants]);

  useEffect(() => {
    if (restaurants && restaurants !== null) {
      setRestaurantName(restaurants.restaurant_name);
      setAddress(restaurants.adress);

      if (
        restaurants.postal_code !== postalCode &&
        restaurants.postal_code !== undefined
      ) {
        setPostalCode(restaurants.postal_code);
      }

      setLatitudeField(parseFloat(restaurants.latitude));
      setLongitudeField(parseFloat(restaurants.longitude));
      setViewDistance(restaurants.view_distance);
      setMarker({
        lat: parseFloat(restaurants.latitude),
        lng: parseFloat(restaurants.longitude),
      });
      setNumberOfBabyChairs(restaurants.number_of_babychairs);
      setLimitPeopleReservation(restaurants.limit_people_reservation);
      setLimitBabyChairsReservation(restaurants.limit_baby_chairs_reservation);
      setEachTime(restaurants.each_time);
      setAutoAcceptLimit(restaurants.auto_accept_limit);
      setAcceptPeoplePerEachTime(restaurants.accept_people_per_each_time);
      setTimezone(restaurants.timezone);
      setAutoAcceptTimeLimit(restaurants.only_auto_accept_before_this_time);
      setAutoAcceptTimeLimitFuture(
        restaurants.only_auto_accept_before_this_time_future,
      );
      setMessageReminderTime(restaurants.send_message_reminder_to_customers);
      setAutoSetTables(restaurants.auto_set_tables);
      setShowTableNotFreedNotification(
        getBooleanValue(restaurants.show_table_not_freed_notification, true),
      );
      setTimeToCancelledWarning(restaurants.time_to_cancelled_warning);
      setRestaurant_description(restaurants.restaurant_description);
      setReconfirmation_duration(restaurants.reconfirmation_duration);
      setReconfirmation_time_before_date(
        restaurants.reconfirmation_time_before_date,
      );
      setStop_allowing_modifications_time_before_date(
        restaurants.stop_allowing_modifications_time_before_date,
      );
      setStop_allowing_cancelling_time_before_date(
        restaurants.stop_allowing_cancelling_time_before_date,
      );

      initialData = {
        restaurantName: restaurants?.restaurant_name,
        address: restaurants?.address,
        postalCode: restaurants?.postal_code,
        latitudeField: parseFloat(restaurants?.latitude),
        longitudeField: parseFloat(restaurants?.longitude),
        viewDistance: restaurants?.view_distance,
        numberOfBabyChairs: restaurants?.number_of_babychairs,
        limitPeopleReservation: restaurants?.limit_people_reservation,
        limitBabyChairsReservation: restaurants?.limit_baby_chairs_reservation,
        eachTime: restaurants?.each_time,
        autoAcceptLimit: restaurants?.auto_accept_limit,
        acceptPeoplePerEachTime: restaurants?.accept_people_per_each_time,
        timezone: restaurants?.timezone,
        autoAcceptTimeLimit: restaurants?.only_auto_accept_before_this_time,
        autoAcceptTimeLimitFuture:
          restaurants?.only_auto_accept_before_this_time_future,
        messageReminderTime: restaurants?.send_message_reminder_to_customers,
        autoSetTables: restaurants?.auto_set_tables,
        showTableNotFreedNotification:
          restaurants?.show_table_not_freed_notification,
        timeToCancelledWarning: restaurants?.time_to_cancelled_warning,
        restaurant_description: restaurants?.restaurant_description,
        reconfirmation_duration: restaurants?.reconfirmation_duration,
        reconfirmation_time_before_date:
          restaurants?.reconfirmation_time_before_date,
        stop_allowing_modifications_time_before_date:
          restaurants?.stop_allowing_modifications_time_before_date,
        stop_allowing_cancelling_time_before_date:
          restaurants?.stop_allowing_cancelling_time_before_date,
      };
    }
  }, [restaurants, restaurant_id]);

  const hasChanges = () => {
    const currentData = {
      restaurantName,
      address,
      postalCode,
      latitudeField,
      longitudeField,
      viewDistance,
      numberOfBabyChairs,
      limitPeopleReservation,
      limitBabyChairsReservation,
      eachTime,
      autoAcceptLimit,
      acceptPeoplePerEachTime,
      timezone,
      autoAcceptTimeLimit,
      autoAcceptTimeLimitFuture,
      messageReminderTime,
      autoSetTables,
      showTableNotFreedNotification,
      timeToCancelledWarning,
      restaurant_description,
      reconfirmation_duration,
      reconfirmation_time_before_date,
      stop_allowing_modifications_time_before_date,
      stop_allowing_cancelling_time_before_date,
    };

    const originalData = {
      restaurantName: restaurants?.restaurant_name,
      address: restaurants?.adress,
      postalCode: restaurants?.postal_code,
      latitudeField: parseFloat(restaurants?.latitude),
      longitudeField: parseFloat(restaurants?.longitude),
      viewDistance: restaurants?.view_distance,
      numberOfBabyChairs: restaurants?.number_of_babychairs,
      limitPeopleReservation: restaurants?.limit_people_reservation,
      limitBabyChairsReservation: restaurants?.limit_baby_chairs_reservation,
      eachTime: restaurants?.each_time,
      autoAcceptLimit: restaurants?.auto_accept_limit,
      acceptPeoplePerEachTime: restaurants?.accept_people_per_each_time,
      timezone: restaurants?.timezone,
      autoAcceptTimeLimit: restaurants?.only_auto_accept_before_this_time,
      autoAcceptTimeLimitFuture:
        restaurants?.only_auto_accept_before_this_time_future,
      messageReminderTime: restaurants?.send_message_reminder_to_customers,
      autoSetTables: restaurants?.auto_set_tables,
      showTableNotFreedNotification: getBooleanValue(
        restaurants?.show_table_not_freed_notification,
        true,
      ),
      timeToCancelledWarning: restaurants?.time_to_cancelled_warning,
      restaurant_description: restaurants?.restaurant_description,
      reconfirmation_duration: restaurants?.reconfirmation_duration,
      reconfirmation_time_before_date:
        restaurants?.reconfirmation_time_before_date,
      stop_allowing_modifications_time_before_date:
        restaurants?.stop_allowing_modifications_time_before_date,
      stop_allowing_cancelling_time_before_date:
        restaurants?.stop_allowing_cancelling_time_before_date,
    };

    return Object.keys(currentData).some(
      (key) =>
        JSON.stringify(currentData[key]) !== JSON.stringify(originalData[key]),
    );
  };

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (hasChanges()) {
        event.preventDefault();
        event.returnValue =
          "Tem certeza de que deseja sair? As alterações não foram salvas.";
      }
    };

    const handleNavigation = (event) => {
      if (hasChanges()) {
        event.preventDefault();

        const confirmLeave = window.confirm(
          "Tem certeza de que deseja sair? As alterações não foram salvas?",
        );

        if (confirmLeave) {
          window.removeEventListener("beforeunload", handleBeforeUnload);
          navigate(event.detail.to);
        }
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("customNavigation", handleNavigation);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("customNavigation", handleNavigation);
    };
  }, [
    restaurantName,
    address,
    postalCode,
    latitudeField,
    longitudeField,
    viewDistance,
    numberOfBabyChairs,
    limitPeopleReservation,
    limitBabyChairsReservation,
    eachTime,
    autoAcceptLimit,
    acceptPeoplePerEachTime,
    timezone,
    autoAcceptTimeLimit,
    autoAcceptTimeLimitFuture,
    messageReminderTime,
    autoSetTables,
    showTableNotFreedNotification,
    timeToCancelledWarning,
    restaurant_description,
    reconfirmation_duration,
    reconfirmation_time_before_date,
    stop_allowing_modifications_time_before_date,
    stop_allowing_cancelling_time_before_date,
  ]);

  function checkEmptyStates() {
    let emptyStates = [];

    if (restaurantName === "") {
      emptyStates.push("Nome do restaurante");
    }

    if (!address) {
      emptyStates.push("Morada");
    }

    if (numberOfBabyChairs === "") {
      emptyStates.push("Numero de cadeiras para bebês");
    }

    if (!limitPeopleReservation) {
      emptyStates.push("Limite de pessoas por reserva");
    }

    if (!limitBabyChairsReservation) {
      emptyStates.push("Limite de cadeiras para bebês por reserva");
    }

    if (autoAcceptLimit < 0) {
      emptyStates.push("Aceitação automatica");
    }

    if (!eachTime) {
      emptyStates.push("Cada tempo");
    }

    if (!acceptPeoplePerEachTime) {
      emptyStates.push("Limite de pessoas por tempo");
    }

    if (emptyStates.length > 0) {
      return (
        "Os seguintes campos não estão corretamente preenchidos: " +
        emptyStates.join(", ")
      );
    }

    return "ok_status";
  }

  function checkForErrorsAndCreateRestaurant() {
    let status_error = checkEmptyStates();
    setErrorMessage(status_error);

    if (status_error === "ok_status") {
      setShowError(false);
      setSizeError("");

      const updatedRestaurantParams = {
        restaurant_name: restaurantName,
        adress: address,
        postal_code: postalCode,
        latitude: latitudeField,
        longitude: longitudeField,
        view_distance: viewDistance,
        number_of_chairs: numberOfChairs,
        number_of_babychairs: numberOfBabyChairs,
        limit_people_reservation: limitPeopleReservation,
        limit_baby_chairs_reservation: limitBabyChairsReservation,
        auto_accept_limit: isGroupSizeAcceptanceBlocked
          ? restaurants?.auto_accept_limit
          : autoAcceptLimit,
        accept_people_per_each_time: acceptPeoplePerEachTime,
        each_time: eachTime,
        timezone: timezone,
        only_auto_accept_before_this_time: isAutoAcceptanceBlocked
          ? restaurants?.only_auto_accept_before_this_time
          : autoAcceptTimeLimit,
        only_auto_accept_before_this_time_future: isAutoAcceptanceBlocked
          ? restaurants?.only_auto_accept_before_this_time_future
          : autoAcceptTimeLimitFuture,
        send_message_reminder_to_customers: messageReminderTime,
        auto_set_tables: autoSetTables,
        show_table_not_freed_notification: showTableNotFreedNotification,
        time_to_cancelled_warning: timeToCancelledWarning,
        restaurant_description: restaurant_description,
        reconfirmation_duration: reconfirmation_duration,
        reconfirmation_time_before_date: reconfirmation_time_before_date,
        stop_allowing_modifications_time_before_date:
          stop_allowing_modifications_time_before_date,
        stop_allowing_cancelling_time_before_date:
          stop_allowing_cancelling_time_before_date,
      };

      if (creating_restaurant === "no") {
        dispatch(updateRestaurant(restaurantId, updatedRestaurantParams));

        if (steps) {
          setCreateRestaurantToFalse();
          handleNextStep();
        }
      } else {
        dispatch(createRestaurant(updatedRestaurantParams));
        setCreateRestaurantToFalse();
        handleNextStep();
      }
    } else {
      setShowError(true);
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    checkForErrorsAndCreateRestaurant();
  };

  useEffect(() => {
    if (restaurantCreated === true) {
      checkForErrorsAndCreateRestaurant();
    }
  }, [restaurantCreated]);

  useEffect(() => {
    setRestaurant_params({
      restaurant_name: restaurantName,
      adress: address,
      postal_code: postalCode,
      latitude: latitudeField,
      longitude: longitudeField,
      view_distance: viewDistance,
      number_of_chairs: numberOfChairs,
      number_of_babychairs: numberOfBabyChairs,
      limit_people_reservation: limitPeopleReservation,
      limit_baby_chairs_reservation: limitBabyChairsReservation,
      accept_people_per_each_time: acceptPeoplePerEachTime,
      each_time: eachTime,
      only_auto_accept_before_this_time: autoAcceptTimeLimit,
      auto_set_tables: autoSetTables,
      show_table_not_freed_notification: showTableNotFreedNotification,
      time_to_cancelled_warning: timeToCancelledWarning,
    });
  }, [
    dispatch,
    restaurantName,
    address,
    postalCode,
    latitudeField,
    longitudeField,
    viewDistance,
    numberOfChairs,
    numberOfBabyChairs,
    limitPeopleReservation,
    limitBabyChairsReservation,
    autoAcceptTimeLimit,
    eachTime,
    acceptPeoplePerEachTime,
    autoSetTables,
    showTableNotFreedNotification,
    timeToCancelledWarning,
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const numericValue = Number(value);

    switch (name) {
      case "restaurant_name":
        setRestaurantName(value);
        break;
      case "adress":
        setAddress(value);
        break;
      case "postalCode":
        setPostalCode(value);
        break;
      case "number_of_chairs":
        setNumberOfChairs(numericValue);
        break;
      case "number_of_babychairs":
        setNumberOfBabyChairs(numericValue);
        break;
      case "limit_people_reservation":
        if (numericValue > acceptPeoplePerEachTime) {
          setSizeError(
            "O número máximo de pessoas por grupo não pode ser maior que o total aceito por horário.",
          );
        } else {
          setSizeError("");
        }

        setLimitPeopleReservation(numericValue);
        break;
      case "limit_baby_chairs_reservation":
        setLimitBabyChairsReservation(numericValue);
        break;
      case "auto_accept_limit":
        if (isGroupSizeAcceptanceBlocked) {
          setShowGroupSizeAcceptanceUpgradeModal(true);
          return;
        }

        setAutoAcceptLimit(numericValue);
        break;
      case "accept_people_per_each_time":
        if (numericValue < limitPeopleReservation) {
          setSizeError(
            "O total aceito por horário não pode ser menor que o número máximo de pessoas por grupo.",
          );
        } else {
          setSizeError("");
        }

        setAcceptPeoplePerEachTime(numericValue);
        break;
      case "each_time":
        setEachTime(numericValue);
        break;
      default:
        break;
    }
  };

  const handleIntervalTimeChange = (option) => {
    setEachTime(option);
  };

  const handleTimeCancelWarning = (value) => {
    setTimeToCancelledWarning(value);
  };

  const handleAutoAcceptTimeLimit = (value) => {
    setAutoAcceptTimeLimit(value);
  };

  const handleReconfirmation_time_before_date = (value) => {
    setReconfirmation_time_before_date(value);
  };

  const handleReconfirmation = (value) => {
    setReconfirmation_duration(value);
  };

  const handleMessageReminderTime = (value) => {
    setMessageReminderTime(value);
  };

  useEffect(() => {
    if (restaurants) {
      console.log(
        "latitude: ",
        restaurants.latitude,
        "longitude: ",
        restaurants.longitude,
      );
      console.log(
        "latitudeField: ",
        latitudeField,
        "longitudeField: ",
        longitudeField,
      );
    }
  }, [restaurants]);

  return (
    <Container>
      <Row>
        <Col sm={12} md={12} xl={12}>
          <CardHeader>
            <CardHeaderTitle>Definições</CardHeaderTitle>
          </CardHeader>

          {isLoading ? (
            <Loader />
          ) : error ? (
            <Messages variant="error">{error}</Messages>
          ) : restaurants ? (
            <Form onSubmit={handleSubmit}>
              <GridContainer>
                <SettingsCard>
                  <SectionTitle>Clientes e aceitação automática</SectionTitle>

                  <Text>
                    Número máximo de pessoas por reserva:
                    <CustomSpan />
                    <BlockedFieldWrapper $blocked={isPeopleLimitBlocked}>
                      <Input
                        type="number"
                        id="limit_people_reservation"
                        name="limit_people_reservation"
                        value={limitPeopleReservation}
                        onChange={handleChange}
                        min={0}
                        disabled={isPeopleLimitBlocked}
                        aria-disabled={isPeopleLimitBlocked}
                      />

                      {isPeopleLimitBlocked && (
                        <BlockedFieldOverlay
                          data-blocked-field-overlay="true"
                          role="button"
                          tabIndex={0}
                          aria-label="Atualizar o plano para configurar o número máximo de pessoas por reserva"
                          onClick={() => setShowPeopleLimitUpgradeModal(true)}
                          onKeyDown={(event) => {
                            if (event.key === "Enter" || event.key === " ") {
                              event.preventDefault();
                              setShowPeopleLimitUpgradeModal(true);
                            }
                          }}
                        >
                          <FontAwesomeIcon icon={faLock} />
                        </BlockedFieldOverlay>
                      )}
                    </BlockedFieldWrapper>
                    <CustomSpan />
                    pessoas.
                  </Text>

                  <BlockedSettingText $blocked={isGroupSizeAcceptanceBlocked}>
                    Aceitar automaticamente grupos até:
                    <CustomSpan />
                    <BlockedFieldWrapper
                      $blocked={isGroupSizeAcceptanceBlocked}
                    >
                      <Input
                        type="number"
                        id="auto_accept_limit"
                        name="auto_accept_limit"
                        value={autoAcceptLimit}
                        onChange={handleChange}
                        min={0}
                        disabled={isGroupSizeAcceptanceBlocked}
                        aria-disabled={isGroupSizeAcceptanceBlocked}
                      />

                      {isGroupSizeAcceptanceBlocked && (
                        <BlockedFieldOverlay
                          data-blocked-field-overlay="true"
                          role="button"
                          tabIndex={0}
                          aria-label="Atualizar o plano para escolher aceitação automática ou manual por tamanho do grupo"
                          onClick={() =>
                            setShowGroupSizeAcceptanceUpgradeModal(true)
                          }
                          onKeyDown={(event) => {
                            if (event.key === "Enter" || event.key === " ") {
                              event.preventDefault();
                              setShowGroupSizeAcceptanceUpgradeModal(true);
                            }
                          }}
                        >
                          <FontAwesomeIcon icon={faLock} />
                        </BlockedFieldOverlay>
                      )}
                    </BlockedFieldWrapper>
                    <CustomSpan />
                    pessoas. Grupos maiores ficam para aceitação manual.
                  </BlockedSettingText>

                  <BlockedSettingText $blocked={isAutoAcceptanceBlocked}>
                    Aceitar automaticamente reservas com antecedência mínima de:
                    <CustomSpan />
                    <BlockedFieldWrapper $blocked={isAutoAcceptanceBlocked}>
                      <InputDayOrHour
                        initialValue={
                          restaurants.only_auto_accept_before_this_time
                        }
                        setValue={
                          isAutoAcceptanceBlocked
                            ? () => {}
                            : handleAutoAcceptTimeLimit
                        }
                      />

                      {isAutoAcceptanceBlocked && (
                        <BlockedFieldOverlay
                          $wideLock={isAutoAcceptanceBlocked}
                          data-blocked-field-overlay="true"
                          role="button"
                          tabIndex={0}
                          aria-label="Atualizar o plano para configurar a antecedência mínima da aceitação automática"
                          onClick={() =>
                            setShowAutoAcceptanceUpgradeModal(true)
                          }
                          onKeyDown={(event) => {
                            if (event.key === "Enter" || event.key === " ") {
                              event.preventDefault();
                              setShowAutoAcceptanceUpgradeModal(true);
                            }
                          }}
                        >
                          <FontAwesomeIcon icon={faLock} />
                        </BlockedFieldOverlay>
                      )}
                    </BlockedFieldWrapper>
                  </BlockedSettingText>

                  <BlockedSettingText $blocked={isAutoAcceptanceBlocked}>
                    Aceitar automaticamente reservas com antecedência máxima de:
                    <CustomSpan />
                    <BlockedFieldWrapper $blocked={isAutoAcceptanceBlocked}>
                      <InputDayOrHourInt
                        initialValue={
                          restaurants.only_auto_accept_before_this_time_future
                        }
                        setValue={
                          isAutoAcceptanceBlocked
                            ? () => {}
                            : setAutoAcceptTimeLimitFuture
                        }
                      />

                      {isAutoAcceptanceBlocked && (
                        <BlockedFieldOverlay
                          $wideLock={isAutoAcceptanceBlocked}
                          data-blocked-field-overlay="true"
                          role="button"
                          tabIndex={0}
                          aria-label="Atualizar o plano para configurar a antecedência máxima da aceitação automática"
                          onClick={() =>
                            setShowAutoAcceptanceUpgradeModal(true)
                          }
                          onKeyDown={(event) => {
                            if (event.key === "Enter" || event.key === " ") {
                              event.preventDefault();
                              setShowAutoAcceptanceUpgradeModal(true);
                            }
                          }}
                        >
                          <FontAwesomeIcon icon={faLock} />
                        </BlockedFieldOverlay>
                      )}
                    </BlockedFieldWrapper>
                  </BlockedSettingText>
                </SettingsCard>

                <SettingsCard>
                  <SectionTitle>Edição e cancelamento</SectionTitle>

                  <Text>
                    Permitir edição com antecedência mínima de:
                    <CustomSpan />
                    <InputDayOrHourInt
                      initialValue={
                        restaurants.stop_allowing_modifications_time_before_date
                      }
                      setValue={setStop_allowing_modifications_time_before_date}
                    />
                  </Text>

                  <Text>
                    Permitir cancelamento com antecedência mínima de:
                    <CustomSpan />
                    <InputDayOrHourInt
                      initialValue={
                        restaurants.stop_allowing_cancelling_time_before_date
                      }
                      setValue={setStop_allowing_cancelling_time_before_date}
                    />
                  </Text>
                </SettingsCard>

                <SettingsCard>
                  <SectionTitle>Cadeiras de bebé</SectionTitle>

                  <Text>
                    Quantas cadeiras de bebé existem?
                    <CustomSpan />
                    <BlockedFieldWrapper $blocked={isReservationExtrasBlocked}>
                      <Input
                        type="number"
                        id="number_of_babychairs"
                        name="number_of_babychairs"
                        value={numberOfBabyChairs}
                        onChange={handleChange}
                        min={0}
                        disabled={isReservationExtrasBlocked}
                        aria-disabled={isReservationExtrasBlocked}
                      />

                      {isReservationExtrasBlocked && (
                        <BlockedFieldOverlay
                          data-blocked-field-overlay="true"
                          role="button"
                          tabIndex={0}
                          aria-label="Atualizar o plano para configurar as cadeiras de bebé"
                          onClick={() =>
                            setShowReservationExtrasUpgradeModal(true)
                          }
                          onKeyDown={(event) => {
                            if (event.key === "Enter" || event.key === " ") {
                              event.preventDefault();
                              setShowReservationExtrasUpgradeModal(true);
                            }
                          }}
                        >
                          <FontAwesomeIcon icon={faLock} />
                        </BlockedFieldOverlay>
                      )}
                    </BlockedFieldWrapper>
                  </Text>

                  <Text>
                    Máximo de cadeiras de bebé por grupo:
                    <CustomSpan />
                    <BlockedFieldWrapper $blocked={isReservationExtrasBlocked}>
                      <Input
                        type="number"
                        id="limit_baby_chairs_reservation"
                        name="limit_baby_chairs_reservation"
                        value={limitBabyChairsReservation}
                        onChange={handleChange}
                        min={0}
                        disabled={isReservationExtrasBlocked}
                        aria-disabled={isReservationExtrasBlocked}
                      />

                      {isReservationExtrasBlocked && (
                        <BlockedFieldOverlay
                          data-blocked-field-overlay="true"
                          role="button"
                          tabIndex={0}
                          aria-label="Atualizar o plano para configurar o máximo de cadeiras de bebé por grupo"
                          onClick={() =>
                            setShowReservationExtrasUpgradeModal(true)
                          }
                          onKeyDown={(event) => {
                            if (event.key === "Enter" || event.key === " ") {
                              event.preventDefault();
                              setShowReservationExtrasUpgradeModal(true);
                            }
                          }}
                        >
                          <FontAwesomeIcon icon={faLock} />
                        </BlockedFieldOverlay>
                      )}
                    </BlockedFieldWrapper>
                  </Text>
                </SettingsCard>

                <SettingsCard>
                  <SectionTitle>Atribuição automática de mesas</SectionTitle>

                  <ToggleRow>
                    <SwitchSlot>
                      <SwitchOnAndOff
                        isOn={autoSetTables}
                        handleToggle={() => setAutoSetTables(!autoSetTables)}
                      />
                    </SwitchSlot>

                    <ToggleText>
                      Atribuir mesas automaticamente às reservas.
                    </ToggleText>
                  </ToggleRow>
                </SettingsCard>

                <SettingsCard>
                  <SectionTitle>Notificações de mesa</SectionTitle>

                  <ToggleRow>
                    <SwitchSlot>
                      <SwitchOnAndOff
                        isOn={showTableNotFreedNotification}
                        handleToggle={() =>
                          setShowTableNotFreedNotification(
                            !showTableNotFreedNotification,
                          )
                        }
                      />
                    </SwitchSlot>

                    <ToggleText>
                      Mostrar aviso quando uma reserva já passou do tempo
                      estimado e ainda não foi marcada como mesa livre.
                    </ToggleText>
                  </ToggleRow>
                </SettingsCard>

                <SettingsCard>
                  <SectionTitle>Fuso horário</SectionTitle>

                  <StyledSelect
                    value={timezone}
                    onChange={(e) => setTimezone(e.target.value)}
                  >
                    {timezones.map((tz) => (
                      <option key={tz} value={tz}>
                        {tz}
                      </option>
                    ))}
                  </StyledSelect>
                </SettingsCard>
              </GridContainer>

              {errorMessage !== "ok_status" && (
                <div style={{ color: "red", marginBottom: "10px" }}>
                  {errorMessage}
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: "20px",
                }}
              >
                <ModernButton color="#EE754C" fontSize="14px" type="submit">
                  Guardar
                </ModernButton>
              </div>
            </Form>
          ) : null}
        </Col>
      </Row>

      <CustomModal
        show={showPeopleLimitUpgradeModal}
        onHide={() => setShowPeopleLimitUpgradeModal(false)}
        title="Limite de pessoas por reserva"
        body={
          <p style={{ margin: 0 }}>
            A configuração do número máximo de pessoas por reserva não está
            incluída no teu plano atual. Atualiza o plano para definires este
            limite.
          </p>
        }
        footer={
          <>
            <ModernButton
              color="#99b0ad"
              onClick={() => setShowPeopleLimitUpgradeModal(false)}
            >
              Agora não
            </ModernButton>

            <ModernButton
              color="#ee754c"
              onClick={() => {
                setShowPeopleLimitUpgradeModal(false);
                navigate(`/pick_plan_and_pay/${restaurants?.id}`);
              }}
            >
              Ver planos
            </ModernButton>
          </>
        }
      />

      <CustomModal
        show={showReservationExtrasUpgradeModal}
        onHide={() => setShowReservationExtrasUpgradeModal(false)}
        title="Extras da reserva"
        body={
          <p style={{ margin: 0 }}>
            A configuração de extras da reserva, como cadeiras de bebé, não está
            incluída no teu plano atual. Atualiza o plano para disponibilizares
            estes extras aos teus clientes.
          </p>
        }
        footer={
          <>
            <ModernButton
              color="#99b0ad"
              onClick={() => setShowReservationExtrasUpgradeModal(false)}
            >
              Agora não
            </ModernButton>

            <ModernButton
              color="#ee754c"
              onClick={() => {
                setShowReservationExtrasUpgradeModal(false);
                navigate(`/pick_plan_and_pay/${restaurants?.id}`);
              }}
            >
              Ver planos
            </ModernButton>
          </>
        }
      />

      <CustomModal
        show={showGroupSizeAcceptanceUpgradeModal}
        onHide={() => setShowGroupSizeAcceptanceUpgradeModal(false)}
        title="Aceitação por tamanho do grupo"
        body={
          <p style={{ margin: 0 }}>
            Escolher aceitação automática e/ou manual das reservas em função do
            tamanho do grupo não está incluído no teu plano atual. Atualiza o
            plano para definires até que tamanho os grupos são aceites
            automaticamente e quando ficam para aprovação manual.
          </p>
        }
        footer={
          <>
            <ModernButton
              color="#99b0ad"
              onClick={() => setShowGroupSizeAcceptanceUpgradeModal(false)}
            >
              Agora não
            </ModernButton>

            <ModernButton
              color="#ee754c"
              onClick={() => {
                setShowGroupSizeAcceptanceUpgradeModal(false);
                navigate(`/pick_plan_and_pay/${restaurants?.id}`);
              }}
            >
              Ver planos
            </ModernButton>
          </>
        }
      />

      <CustomModal
        show={showAutoAcceptanceUpgradeModal}
        onHide={() => setShowAutoAcceptanceUpgradeModal(false)}
        title="Antecedência da aceitação automática"
        body={
          <p style={{ margin: 0 }}>
            As regras de antecedência da aceitação automática não estão
            incluídas no teu plano atual. Atualiza o plano para definires com
            que antecedência as reservas podem ser aceites automaticamente.
          </p>
        }
        footer={
          <>
            <ModernButton
              color="#99b0ad"
              onClick={() => setShowAutoAcceptanceUpgradeModal(false)}
            >
              Agora não
            </ModernButton>

            <ModernButton
              color="#ee754c"
              onClick={() => {
                setShowAutoAcceptanceUpgradeModal(false);
                navigate(`/pick_plan_and_pay/${restaurants?.id}`);
              }}
            >
              Ver planos
            </ModernButton>
          </>
        }
      />
    </Container>
  );
}

export default RestaurantSettingsUpdate;

const Form = styled.form`
  width: 100%;
  margin: 0 auto;
  padding: 0 10px;
`;

const BlockedFieldWrapper = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  border-radius: 6px;

  ${({ $blocked }) =>
    $blocked
      ? `
        background: rgba(238, 117, 76, 0.08);
        box-shadow: 0 0 0 2px rgba(238, 117, 76, 0.22);

        input,
        select,
        textarea {
          border-color: #EE754C !important;
          background-color: #fff7f4 !important;
          box-shadow: none !important;
        }

        > *:not([data-blocked-field-overlay="true"]) {
          pointer-events: none;
        }
      `
      : ""}
`;

const BlockedFieldOverlay = styled.span`
  position: absolute;
  inset: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: ${({ $wideLock }) => ($wideLock ? "140px" : "8px")};
  color: #ee754c;
  cursor: pointer;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.01);

  svg {
    filter: drop-shadow(0 1px 1px rgba(255, 255, 255, 0.85));
  }
`;

const BlockedSettingText = styled(Text)`
  position: relative;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-width: 0;
`;

const SwitchSlot = styled.div`
  flex: 0 0 58px;
  width: 58px;
  min-width: 58px;
  max-width: 58px;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  & > * {
    flex-shrink: 0;
  }
`;

const ToggleText = styled(Text)`
  flex: 1 1 auto;
  min-width: 0;
  margin: 0 !important;
  line-height: 1.35;
`;

const Button = styled.button`
  display: inline-block;
  font-weight: 400;
  color: #fff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  background-color: #007bff;
  border: 1px solid #007bff;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 4px;

  &:hover {
    background-color: #0069d9;
    border-color: #0062cc;
  }
`;
